import './index.css';

import React, { useEffect, useLayoutEffect, useState } from 'react';
interface IOSScrollProps {
  scrollRef?: unknown;
  scrollLeft?: number;
  width?: number;
}

const IOSScroll: React.FC<IOSScrollProps> = ({ scrollRef, scrollLeft, width = 200 }) => {
  if (!scrollRef.current) {
    return null;
  }
  const [innerScrollWidth, setInnerScrollWidth] = useState(0);
  const [isOverflow, setIsOverflow] = React.useState(false);

  useEffect(() => {
    if (scrollRef.current) {
      setInnerScrollWidth((scrollRef.current.clientWidth / scrollRef.current.scrollWidth) * width);
    }
  }, [scrollRef]);

  useLayoutEffect(() => {
    const { current } = scrollRef;
    const trigger = () => {
      const hasOverflow = current.scrollWidth > current.clientWidth;
      if (hasOverflow) setIsOverflow(true);
    };
    if (current) {
      trigger();
    }
  }, [scrollRef]);

  const { clientWidth, scrollWidth } = scrollRef.current;
  const scrollMax = scrollWidth - clientWidth;
  const finalLeft = (scrollLeft * (width - innerScrollWidth)) / scrollMax;
  return isOverflow ? (
    <div style={{ width: `${width}px` }} className="ios-outer-scroll">
      <div
        className="ios-inner-scroll"
        style={{ width: innerScrollWidth, left: scrollLeft === 0 ? scrollLeft : finalLeft }}
      ></div>
    </div>
  ) : null;
};

export default IOSScroll;
